/**
 * Every cross-link in the admin panel. A page that shows a user, listener,
 * call or recharge links to it through here, so "open this listener" means the
 * same URL everywhere and the target pages only have one set of params to read.
 */
const enc = encodeURIComponent;

export const adminLinks = {
  /**
   * Listener details — opened beside the Listeners list (master–detail), never
   * on a page of their own. `tab` = overview | application | login | online |
   * calls | live | earnings | employment | payouts | referral | status.
   * The old `/listeners/:id` address redirects here.
   */
  listener: (id: string, tab?: string) => `/listeners?listener=${enc(id)}${tab ? `&tab=${enc(tab)}` : ''}`,
  /** Listeners list on one tab (all | pending | rejected | online | busy | live | …). */
  listeners: (tab: string) => `/listeners?status=${enc(tab)}`,
  /** One agency's detail page. `tab` = overview | users | recharges | commission | payouts. */
  agency: (id: string, tab?: string) => `/agencies/${enc(id)}${tab ? `?tab=${enc(tab)}` : ''}`,
  /** Users page with that user's detail drawer open. */
  user: (id: string) => `/users?user=${enc(id)}`,
  /** One call, detail drawer open. */
  call: (id: string) => `/calls?call=${enc(id)}`,
  /** Every call a user made. */
  userCalls: (userId: string) => `/calls?userId=${enc(userId)}`,
  /** Every call a listener received. */
  listenerCalls: (listenerId: string) => `/calls?listenerId=${enc(listenerId)}`,
  /** One recharge, detail drawer open. */
  recharge: (id: string) => `/refunds?order=${enc(id)}`,
  /** Every recharge attempt of a user. */
  userRecharges: (userId: string) => `/refunds?userId=${enc(userId)}`,
  /** Recharges that were paid but not credited. */
  paidNotCredited: '/refunds?status=paid_credit_pending',
  payoutQueue: '/payouts',
  payoutHistory: (q?: string) => `/payouts?tab=history${q ? `&q=${enc(q)}` : ''}`,
} as const;
